export enum TipoPessoaLotada {
  Defensor = 1,
  Colaborador = 2,
  Estagiario = 3,
}